module.exports = __webpack_public_path__ + "img/20190619164149QQ截图20190617164126.a2c3272a.png";